import React from 'react';
import { useSelector } from 'react-redux';
import { Fire, Time, Tools } from '../../services'

import { Input, Button, Card, CardBody, CardHeader } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, ListContainer } from '../Reusable'

import FadeIn from 'react-fade-in';
import QrReader from 'react-qr-scanner'

import ScanResults from './ScanResults'

const { useHistory } = require('react-router-dom')

interface Props {
  
}
const ScanScreen: React.FC<Props> = (props) => {

  const [scan, setScan] = React.useState<any>(null)

  const test = () => {
    setScan({ text: '244242' })
  }

  const onScan = (val) => {
    if (val && !scan)
      setScan(val)
  }

  const Scanner = React.useMemo(() => {
    return (
      <QrReader
        style={{width: '100%', height: '100%'}}
        onError={() => alert('Veuillez activer votre caméra et raffraichir la page')}
        onScan={onScan}
        facingMode='user'
      />
    )
  }, [])

  return (
    <div className="wrapper scan">
      <Headerbar
        title={'Scan'}
        renderButtons={() => (
          <div onClick={test}>Test</div>
        )}
        />
      <div className="content-wrapper">
       
        <div style={{position: 'relative'}}>
          {Scanner}

          <ScanResults
            code={scan ? scan.text : undefined}
            onClose={() => setScan(null)}
            />
        </div>

      </div>
    </div>
  );
}

export default ScanScreen